<div *ngIf="ne">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>computer</mat-icon> {{!ne.id ? 'Create new Network Element' : ('Network Element - ' + ne.name)}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="validatingCompany || companyValidationFailed || !ne.companyId || !form.form.valid">
        <mat-icon>{{!ne.id ? 'add' : 'save'}}</mat-icon>
        {{(ne.id ? 'Update ' : 'Add ')}}
      </button>
      <micro-delete-confirm *ngIf="ne.id" (onConfirm)="delete()"></micro-delete-confirm>
    </div>
  </div>


  <mat-toolbar *ngIf="ne && ne.error" class="primary">
    {{ne.error}}
  </mat-toolbar>

  <div class="padded">
    <p *ngIf="companyValidationFailed">
      Unable to validate the selected records for this company.
      <button mat-button type="button" (click)="validateCompanySelections()">Retry</button>
    </p>
    <form #form="ngForm" role="form" class="vbox">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Configure NE</th>
          </tr>
        </thead>
        <tbody>
        <tr *ngIf="authService.isSystemUser()">
          <th><micro-valid-label for="companyId" [model]="companyId" label="Company"></micro-valid-label></th>
          <td>
            <micro-company-select #companyId="ngModel" [ngModel]="ne.companyId" (ngModelChange)="onCompanyChange($event)" [required]="true" id="companyId" name="companyId"></micro-company-select>
          </td>
        </tr>
        <tr>
          <th><micro-valid-label for="name" [model]="name" label="Name"></micro-valid-label></th>
          <td>
            <input #name="ngModel" [(ngModel)]="ne.name" required placeholder="Name" id="name" name="name">
          </td>
        </tr>
          <tr>
            <th><micro-valid-label for="host" [model]="host" label="DNS / IP"></micro-valid-label></th>
            <td>
              <input #host="ngModel" [(ngModel)]="ne.host" required placeholder="Hostname/IP" id="host" name="host">
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="ipAddress" [model]="ipAddress" label="IP Address"></micro-valid-label></th>
            <td>
              <input #ipAddress="ngModel" [(ngModel)]="ne.ipAddress" placeholder="IP Address" id="ipAddress" name="ipAddress" />
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="net" [model]="net" label="Network Type"></micro-valid-label></th>
            <td>
              <micro-net-select #net="ngModel" [(ngModel)]="ne.netId" [required]="true" id="net" name="net" [companyId]="ne.companyId" [disabled]="validatingCompany || !ne.companyId"></micro-net-select>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="neType" [model]="neType" label="NE Type"></micro-valid-label></th>
            <td>
              <!-- <input #neType="ngModel" [(ngModel)]="ne.neType"  placeholder="NE Type" id="neType" name="neType"> -->
              <micro-select-pagination
                [disabled]="validatingCompany || !ne.companyId"
                #neType
                apiUrl="/domain/neTypes"
                [params]="{companyId: ne.companyId}"
                routerBase="neTypes"
                [(id)]="ne.neTypeId"
                [defaultOption]="selectedNeType"
                placeholder="NE Type"
                (objectChange)="onNeTypeChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="hardwareStatus" [model]="hardwareStatus" label="Hardware Status"></micro-valid-label></th>
            <td>
              <input #hardwareStatus="ngModel" [(ngModel)]="ne.hardwareStatus" placeholder="Hardware Status" id="hardwareStatus" name="hardwareStatus" />
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="operationalStatus" [model]="operationalStatus" label="Operational Status"></micro-valid-label></th>
            <td>
              <input #operationalStatus="ngModel" [(ngModel)]="ne.operationalStatus" placeholder="Operational Status" id="operationalStatus" name="operationalStatus" />
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="classCodeId" [model]="$any(classCodeId)" label="Class Code"></micro-valid-label></th>
            <td>
              <micro-select-pagination
                [disabled]="validatingCompany || !ne.companyId"
                #classCodeId
                apiUrl="/domain/cmdbClassCodes"
                [params]="{companyId: ne.companyId}"
                routerBase="classCodes"
                [(id)]="ne.classCodeId"
                [defaultOption]="selectedClassCode"
                placeholder="Class Code"
                (objectChange)="onClassCodeChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="hostingId" [model]="$any(hostingId)" label="Hosting"></micro-valid-label>
            </th>
            <td>
              <micro-select-pagination
                [disabled]="validatingCompany || !ne.companyId"
                #hostingId
                apiUrl="/domain/cmdbHostingPlatform"
                [params]="{companyId: ne.companyId}"
                routerBase="hostingPlatforms"
                [(id)]="ne.hostingId"
                [defaultOption]="selectedHostingPlatform"
                placeholder="Hosting Platform"
                (objectChange)="onHostingPlatformChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>Cluster</th>
            <td>
              <micro-select-pagination
                [disabled]="validatingCompany || !ne.companyId"
                apiUrl="/domain/cmdbClusters"
                routerBase="cmdbClusters"
                [(id)]="ne.clusterId"
                [defaultOption]="selectedCluster"
                [params]="{companyId: ne.companyId}"
                placeholder="Cluster"
                [required]="false"
                (objectChange)="selectedCluster = $event"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="location" [model]="location" label="Location"></micro-valid-label></th>
            <td>
              <micro-location-select #location="ngModel" [(ngModel)]="ne.locationId" [required]="true" id="location" name="location" [companyId]="ne.companyId" [disabled]="validatingCompany || !ne.companyId"></micro-location-select>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="osVersionId" [model]="$any(osVersionId)" label="OS Version"></micro-valid-label></th>
            <td>
              <micro-select-pagination
                [disabled]="validatingCompany || !ne.companyId"
                #osVersionId
                apiUrl="/domain/cmdbOsVersions"
                [params]="{companyId: ne.companyId}"
                routerBase="osVersions"
                [(id)]="ne.osVersionId"
                [defaultOption]="selectedOsVersion"
                placeholder="OS Version"
                (objectChange)="onOsVersionChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="applicationTag" [model]="$any(applicationTagId)" label="Application Tag"></micro-valid-label></th>
            <td>
              <micro-select-pagination
                [disabled]="validatingCompany || !ne.companyId"
                #applicationTagId
                apiUrl="/domain/cmdbApplicationTags"
                [params]="{companyId: ne.companyId}"
                routerBase="applicationTags"
                [(id)]="ne.applicationTagId"
                [defaultOption]="selectedApplicationTag"
                placeholder="Application Tag"
                (objectChange)="onApplicationTagChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="environment" [model]="environment" label="Environment"></micro-valid-label></th>
            <td>
              <micro-environment-select #environment="ngModel" [(ngModel)]="ne.environmentId" [required]="true" id="environment" name="environment" [companyId]="ne.companyId" [disabled]="validatingCompany || !ne.companyId"></micro-environment-select>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="cpuCount" [model]="cpuCount" label="CPU Count"></micro-valid-label></th>
            <td>
              <input #cpuCount="ngModel" [(ngModel)]="ne.cpuCount" placeholder="CPU Count" id="cpuCount" name="cpuCount" type="number" step="1" min="0" />
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="cpuCoreCount" [model]="cpuCoreCount" label="CPU Core Count"></micro-valid-label></th>
            <td>
              <input #cpuCoreCount="ngModel" [(ngModel)]="ne.cpuCoreCount" placeholder="CPU Core Count" id="cpuCoreCount" name="cpuCoreCount" type="number" step="1" min="0" />
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="cpuCoreThread" [model]="cpuCoreThread" label="CPU Core Thread"></micro-valid-label>
            </th>
            <td>
              <input #cpuCoreThread="ngModel" [(ngModel)]="ne.cpuCoreThread" placeholder="CPU Core Thread" id="cpuCoreThread" name="cpuCoreThread" type="number" step="1" min="0" />
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="ram" [model]="ram" label="RAM"></micro-valid-label></th>
            <td>
              <input #ram="ngModel" [(ngModel)]="ne.ram" placeholder="RAM" id="ram" name="ram" type="number" step="1" min="0" />
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="description" [model]="description" label="Description"></micro-valid-label></th>
            <td>
              <input #description="ngModel" [(ngModel)]="ne.description" placeholder="Description" id="description" name="description" />
            </td>
          </tr>
          <tr>
            <th>NEGs</th>
            <td>
              <fieldset [disabled]="validatingCompany || !ne.companyId" style="border: 0; padding: 0; margin: 0;"><micro-objectGroup-picklist [companyId]="ne.companyId" type="NE" [(selectedItems)]="ne.negs"></micro-objectGroup-picklist></fieldset>
            </td>
          </tr>
          <tr>
            <th>Sites</th>
            <td>
              <fieldset [disabled]="validatingCompany || !ne.companyId" style="border: 0; padding: 0; margin: 0;"><micro-site-picklist [companyId]="ne.companyId"  [(selectedItems)]="ne.sites"></micro-site-picklist></fieldset>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>

